import {
  container,
  title,
  main,
  mainRaised,
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  whiteColor,
  cardTitle,
  description
} from "assets/jss/material-kit-pro-react.jsx";


const dashGeneralPageStyle = {
  cardTitle,
  cardCategory: {
    margin: "0",
    color: "#999999"
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "10px !important",
    marginBottom: "3px !important"
  },
  cardIconSubTitle: {
    ...cardTitle,
    fontSize: "small",
    marginTop: "3px !important",
    marginBottom: "6px !important"
  },
  cardBodyMap: {
    padding: "5px 2px !important"
  },
  cardDescription: {
    ...description,
    textAlign: "center"
  },
  legendTitle: {
    color: grayColor,
    margin: "10px 0 !important",
    display: "flex"
  },
  primary: {
    color: primaryColor
  },
  warning: {
    color: warningColor
  },
  danger: {
    color: dangerColor
  },
  success: {
    color: successColor
  },
  info: {
    color: infoColor
  },
  rose: {
    color: roseColor
  },
  gray: {
    color: grayColor
  },
  white: {
    color: whiteColor
  },
  whiteOutline: {
    borderWidth: "2px",
    borderStyle: "solid",
    borderColor: whiteColor
  },
  cardFooter: {
    display: "block",
    color: "rgba(0,0,0,0.8)"
  },

  container: {
    ...container,
    zIndex: "2",
    position: "relative"
  },
  title: {
    ...title,
    color: "#FFFFFF"
  },
  main: {
    ...main,
    ...mainRaised,
    padding: "20px 20px 0px 20px"
  },
  block: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block"
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto"
  },
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0"
  },
  left: {
    float: "left!important",
    display: "block"
  },
  right: {
    padding: "15px 0",
    margin: "0",
    float: "right"
  },
  icon: {
    width: "18px",
    height: "18px",
    top: "3px",
    position: "relative"
  },
  iconWrapper: {
    color: "rgba(255, 255, 255, 0.76)",
    margin: "10px auto 0",
    width: "130px",
    height: "130px",
    border: "1px solid #E5E5E5",
    borderRadius: "50%",
    lineHeight: "174px",
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      fontSize: "55px",
      lineHeight: "55px"
    },
    "& svg": {
      width: "55px",
      height: "55px"
    }
  },
  iconWrapperColor: {
    borderColor: "rgba(255, 255, 255, 0.25)"
  },
  iconInfo: {
    color: infoColor
  },
  marginTop30: {
    marginTop: "30px"
  },
  marginBottom20: {
    marginBottom: "20px"
  },
  cardRaised: {
    zIndex: 4
  },

  textRight: {
    textAlign: "right"
  },
  textLeft: {
    textAlign: "left"
  },
  textCenter: {
    textAlign: "center"
  },

  clcBox: {
    color: "#FFF",
    display: "inline-block",
    width: "20px",
    height: "20px",
    border: "1px solid #ccc",
    marginRight: "10px"
  },

  sizeTiny: {
    padding: "2px 2px",
    minWidth: "32px",
    minHeight: "20px"

  }
};

export default dashGeneralPageStyle;
